export const de = {
  // CYCLES
  cycles: {
    cycles: [
      "STRUCTURAL COLLAGE",
      "INTERIOR",
      "EGG DOMINATION",
      "SKULPTUR",
      //"POESIE",
      "SONSTIGES",
    ],
  },

  // ERROR
  error: {
    errorHeader: "Seite nicht gefunden",
    errorButton: "Navigieren Sie zur Startseite",
  },

  // GDPR
  cookieBanner: {
    cookieBannerParagraph:
      "Wir verwenden Cookies um die Benutzerfreundlichkeit dieser Seite zu verbessern. Bei weiterem Verwenden dieser Seite stimmen Sie unseren Datenschutz Richtlinien zu.",
    cookieBannerLink: "Mehr Details",
    cookieBannerButton: "Einverstanden",
  },

  // MENU
  menu: {
    menuButton: "MENU",
    closeMenuButton: "SCHLIEßEN",
    artworksMenuButton: "Arbeiten",
    exhibitionsMenuButton: "Ausstellungen",
    biographyMenuButton: "Über mich",
    contactMenuButton: "Kontakt",
    backToMainPage: "Zurück",
    backToExhibitionsPage: "Zurück zu den Ausstellungen",
    backToCyclesPage: "Zurück zu den Zyklen",
  },

  poetry: {
    poetryHeader: "Poesie",
  },

  artworks: {
    "0082": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0081": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0080": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0079": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0078": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0077": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0076": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0075": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0074": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0073": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0072": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0071": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0070": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0069": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0068": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0067": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    /*"0066": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription:
        'Ikea hanging lamp - REGOLIT HEMMA hanging lampshade.  Author\'s modification: orange KOBRA spray, paper, glue\n"ORANGE"',
    },*/

    "0065": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription:
        'Lighting project, lamp.\nMade of metal and black plastic mesh. Created on the basis and shaft of a transformed paper lamp from @ikeawnetrza "STORM". Bulbs are mounted on the lamp.',
    },

    "0064": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0063": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0062": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0061": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0060": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0059": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0058": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0057": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },
    /*
    "0056": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },
*/
    "0055": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0054": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0053": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0052": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0051": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0050": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0049": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0048": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0047": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0046": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0045": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0044": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0043": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0042": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0041": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0040": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0039": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0038": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0037": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0036": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0035": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0034": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0033": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0032": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0031": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0030": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0029": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0028": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0027": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0026": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0025": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0024": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0023": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0022": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0021": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0020": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0019": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0018": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0017": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },
    /*
    "0016": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },
*/
    "0015": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0014": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0013": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0012": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0011": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0010": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0009": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0008": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0007": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0006": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0005": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0004": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0003": {
      artworkAvailability: "ERHÄRTLICH",
      artworkDescription: "",
    },

    "0002": {
      artworkAvailability: "AUSVERKAUFT",
      artworkDescription: "",
    },

    "0001": {
      artworkAvailability: "ERHÄRTLICH ",
      artworkDescription: "",
    },

    "0000": {
      artworkAvailability: "",
      artworkDescription: "",
    },
  },

  // EXHIBITIONS
  exhibitions: {
    exhibitionsHeader: "Ausstellungen",
    exhibitionsContainer: {
      "0007": {
        exhibitionTitle: 'Ausstellung moderner Kunst "BIOART"',
        exhibitionDate: "der November 2021 – der Dezember 2021",
        exhibitionDescription: "",
      },

      "0006": {
        exhibitionTitle:
          "Ausstellung moderner Kunst aus der Sammlung von Piotr Fajkis in der Ignacy Mine in der Stadt Rybnik, Polen",
        exhibitionDate: "der Januar 2020 – der Februar 2020",
        exhibitionDescription:
          "Sammlung von Werken junger und älterer Künstler, mit der Präsentation von Michał Król’s Arbeit mit dem Titel „Das Netzwerk”.",
      },

      "0005": {
        exhibitionTitle:
          "Jasinski & friends VII – Kunstausstellung in der Galerie „Przy Teatrze Narodowym” in Warschau",
        exhibitionDate: "der November 2019 – der Januar 2020",
        exhibitionDescription:
          "The 7th edition of Jasinski & friends kollektive Kunstausstellung wurde von Dominik Jasinski in Zusammenarbeit mit der Galerie„Przy Teatrze Narodowym” in Warschau organisiert. Die insgesamt 26 Werke polnischer Künstler enthielten Gemälde, Grafiken und Fotografien. Drei Arbeiten von Michał Król mit den Titeln „Erdschädel”, “Goldschädel” und “Kupferschädel” waren dabei.",
      },

      "0004": {
        exhibitionTitle:
          "Vernisage von „Innenarbeiten” in der Popart Galerie in Poznan.",
        exhibitionDate: "der Oktober 2018 – der November 2018",
        exhibitionDescription:
          "Das Röntgenbild zeigt alles unsichtbare für das bloße Auge:: unsere innere Schale, Struktur, organische Materie als Sinnbild für das Innere, eine emotionale Landschaft illustriert mit Farben, die für unsere Gefühle, musikalisches, physisches und erotisches Empfinden stehen. Es ist aber auch ein Tribut an elektronische Technomusik, welches Teile von Futurismus, Finsternis, Modernität, ebenso technisch wie ein Röntgengerät als diagnostisches Mittel für künstlerisches Schaffen.",
      },

      "0003": {
        exhibitionTitle:
          "21. Internation Kongress Umweltschutz Envicon Environment auf der MTP Poznań Expo",
        exhibitionDate: "der Oktober 2017 – der Oktober 2017",
        exhibitionDescription:
          "Dieser Kongress ist ein Forum für die wichtigsten Repräsentanten der Landes- und Lokalregierung/Administration, einheimische und internationale Vertreter von Firmen und Experten im Bereich Abfallmanagement, sowie Wasserversorgung und Material-Wiederverwertung. Als Teil des Recycling in Relation mit dem “Zero Waste” Trend, wurden dort Strukturelle Kollagen präsentiert, die zeigten, wie industrielle Reste kunstvoll aufbereitet werden können, indem Zero Waste und Kunst in Verbindung gebracht wird.",
      },

      "0002": {
        exhibitionTitle:
          "Vernissage STRUCTURAL COLLAGE im Geranium Caffe in Poznań",
        exhibitionDate: "der Juni 2017 – der September 2017",
        exhibitionDescription:
          "Die Vernissage fand in einem der beliebtesten Restaurants in Poznań statt - Geranium Caffe Vege Cousine, mit Arbeiten, die die natürlichen Prozesse einen anderen Kontext setzten, indem abstrakte Kreationen die Beziehung von Mensch und Maschine darstellten.",
      },

      "0001": {
        exhibitionTitle:
          "Ausstellung und Veranstaltung „STRUCTURAL COLLAGE” in Bydgoszcz",
        exhibitionDate: "der März 2017 – der Mai 2017",
        exhibitionDescription:
          "Diese Ausstellung fand an der Nationalbibliothek Nr. 14 in Bydgoszcz statt. Die Intention war es, moderne Kunst dem gewöhnlichen Publikum nahezubringen und mit dieser spielerisch zu interagieren. Die Besucher waren eingeladen an einer “sozialen Collage” teilzunehmen. Die Bibliothek stellte hierfür ihr großes Fenster zur Verfügung, wo ein Farbenspiel die Besucher in ihren Bann ziehen sollte.",
      },
    },
  },

  // BIOGRAPHY
  biography: {
    biographyHeader: "Über mich",
    biographyParagraph:
      "Geboren in 1984 in der Region Kujawy und Absolvent eines Masterstudiengangs  in Pädagogik an der Kazimierz Wielki Universität in Bydgoszcz, Polen. Seine Arbeiten lassen sich derzeit in zwei Kategorien einteilen: Struktur-Kollage, die mit Hilfe von Maschinen seine strukturellen Gemälde entstehen lässt, und Interior, welches einen Einblick ins Innere gibt, sowohl wörtlich als auch figürlich, mit Hilfe von Röntgen- und Magnetresonanzbildern. Seine Inspiration schöpfte er aus Fabriken in Bydgoszcz, wo er neben dem Studium gejobbt hatte. Von dort hatte er verschiedene Industriematerialien zu Kunstwerken zusammengesetzt. Seine charakteristischen Collagen und Gemälde sollen vermitteln, dass Materialien wiederverwertet werden können und in einen neuen, einzigartigen und lebendigen Kontext sein können. Sein Stil ist inspiriert von Strukturalismus und Industrialismus, welche die Schönheit der Dinge unseres Lebens darstellen. Seine Vorbilder sind Alberto Burri und Hans Rudolf Giger, wessen Arbeiten ihm dazu inspirierten seine eigene strukturelle Collage zu kreieren. Er hat bereits viele Länder bereist, u. A. Australien, Schweiz, Deutschland und Großbritannien. Zur Zeit lebt und arbeitet er in Poznań, Polen.",
    biographyImage: "./images/biography/BiographyImage.jpg",
  },

  // CONTACT
  contact: {
    contactHeader: "Kontakt",
    contactButton: "Schreiben Sie mir",
    contactData: "Deine Kontaktdaten",
    contactEmail: "Deine E-Mail-Adresse",
    contactMessage: "Nachrichtentext",
    contactErrorBackUp:
      "Beim Senden der Nachricht ist ein Fehler aufgetreten. Bitte sende sie direkt an",
    contactErrorInvalidEmail: "Ungültige E-Mail-Adresse.",
    contactErrorSending: "Wird gesendet...",
    contactSuccessSending: "Nachricht wurde gesendet.",
  },
};
